import { Component, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { NavController } from "@ionic/angular";
import { DefaultPageComponent } from "../../../shared/page/default-page.component";
import { BackNativeService } from "../../../shared/service/comunicator-native/back-native/back-native";
import { ReturnNativeService } from "../../../shared/service/comunicator-native/return-native/return-native";
import { JourneyService } from "../../../shared/service/journey/journey.service";
import { AnalycticsNativeService } from "../../../shared/service/comunicator-native/analytics-native/analyctics-native";
import { AnalyticsPageModel } from "../../../shared/model/analyticsPage";
import { AnalyticsPageService } from "../../../shared/service/analytics/analytics-page.service";
import { TrackTypes } from "../../../shared/service/journey/tracks/model/track-types";
import { DomainOrigin } from "../../../../app/shared/service/domains/model/domain-origin";
import { ReturnHomeService } from "../../../../app/shared/service/comunicator-native/return-home/return-home";
import { AnalyticsGA4PageService } from "../../../shared/service/analytics-ga4-pages/analytics-ga4-page.service";
import { AnalyticsGA4PagesModel } from "../../../shared/service/analytics-ga4-pages/analytics-ga4-pages-models";
import { CaronteLikertService } from "../../../shared/service/caronte-likert/caronte-likert.service";
import { CaronteCustodiaService } from "../../../shared/service/caronte-custodia/caronte-custodia.service";

@Component({
  selector: "app-overview-complete-registration",
  templateUrl: "./overview-user-data.component.html",
  styleUrls: ["./overview-user-data.component.scss"],
})
export class OverviewUserDataComponent
  extends DefaultPageComponent
  implements OnInit
{
  headerId = "overview-status";
  titlePage = `Meus dados cadastrais`;
  nameNative = "";
  listStatus = [];
  analyticsPage: AnalyticsPageModel;
  analyticsPageGA4: AnalyticsGA4PagesModel;
  labelBtnBack = "voltar";
  cameFromLogin: string;
  viewContent = false;
  loading = true;
  alertVoiceOver = false;
  dataStatus: string;
  dataStatusNumber: number;
  dataStep: string;

  constructor(
    public backNativeService: BackNativeService,
    public journeyService: JourneyService,
    public router: NavController,
    public returnNativeService: ReturnNativeService,
    private title: Title,
    public analycticsNativeService: AnalycticsNativeService,
    private analyticsPageService: AnalyticsPageService,
    private analyticsGA4PageService: AnalyticsGA4PageService,
    private returnHomeService: ReturnHomeService,
    private caronteLikertService: CaronteLikertService,
    private caronteCustodiaService: CaronteCustodiaService
  ) {
    super(backNativeService, journeyService, router, returnNativeService);
    this.getAnalyticsPage();
    this.getAnalyticsPageGA4();
    this.journeyService?.registratioJourney?.data?.idInvestor
      ? this.router.navigateForward(`/?journey=${TrackTypes.UPDATE_REGISTRATION}`)
      : (this.loading = false);
  }

  ngOnInit() {
    this.setTitle();
    this.cameFromLogin = localStorage.getItem("cameFromLogin");
    this.checkPageHasLoading();
    this.checkStatusPage();
    this.initializeCaronte();
  }

  initializeCaronte(): void {
    if (this.domainOrigin !== DomainOrigin.Mock) {
      this.caronteLikertService.initializeSession();
      this.caronteCustodiaService.initializeSession();
    }
  }

  checkPageHasLoading() {
    if (this.cameFromLogin) {
      this.labelBtnBack = "Tela carregada, voltar";
      this.headerFocus();
      setTimeout(() => (this.labelBtnBack = "voltar"), 1000);
    } else {
      this.headerFocus();
    }
  }

  getAnalyticsPage() {
    this.analyticsPage = this.analyticsPageService.setAnalyticsPage();
  }

  getAnalyticsPageGA4() {
    this.analyticsPageGA4 = this.analyticsGA4PageService.setAnalyticsPageGA4();
  }

  analyticsData() {
    const it_pagename = this.analyticsPage.checkData;
    this.analycticsNativeService.analyticsTrackStateCommunicator(it_pagename);
  }

  sendTrackGA4LoadPage() {
    const paramDefautl = {
      event_name: this.analyticsPageGA4.eventNameScreenView,
      status: this.dataStatus ? this.dataStatus : "completo",
      description: this.dataStatusNumber
        ? "quantidade-de-etapas-pendentes:" + this.dataStatusNumber.toString()
        : "quantidade-de-etapas-pendentes:" + 0,
      custom_path: this.analyticsPageGA4.customPathOverview,
      implementation_team: this.analyticsPageGA4.implementationTeam,
    };

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl);
  }

  sendTrackGA4CompleteLater() {
    const paramDefautl = {
      event_name: this.analyticsPageGA4.eventNameClick,
      status: this.dataStatus ? this.dataStatus : "completo",
      description: this.dataStatusNumber
        ? "quantidade-de-etapas-pendentes:" + this.dataStatusNumber.toString()
        : "quantidade-de-etapas-pendentes:" + 0,
      custom_path: this.analyticsPageGA4.customPathOverview,
      implementation_team: this.analyticsPageGA4.implementationTeam,
      detail: "completar-depois"
    };

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl);
  }

  sendTrackGA4CompleteNow() {
    const paramDefautl = {
      event_name: this.analyticsPageGA4.eventNameClick,
      status: this.dataStatus ? this.dataStatus : "completo",
      description: this.dataStatusNumber
        ? "quantidade-de-etapas-pendentes:" + this.dataStatusNumber.toString()
        : "quantidade-de-etapas-pendentes:" + 0,
      custom_path: this.analyticsPageGA4.customPathOverview,
      implementation_team: this.analyticsPageGA4.implementationTeam,
      detail: "completar-cadastro"
    };

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl);
  }

  sendTrackGA4ContactData() {
    const paramDefautl = {
      event_name: this.analyticsPageGA4.eventNameVisualization,
      custom_path: this.analyticsPageGA4.customPathOverview,
      detail: "Dados de contato",
      description: this.dataStatusNumber
        ? "quantidade-de-etapas-pendentes:" + this.dataStatusNumber.toString()
        : "quantidade-de-etapas-pendentes:" + 0,
      implementation_team: this.analyticsPageGA4.implementationTeam,
    };

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl);
  }

  sendTrackGA4PersonalData() {
    const paramDefautl = {
      event_name: this.analyticsPageGA4.eventNameVisualization,
      custom_path: this.analyticsPageGA4.customPathOverview,
      detail: "Dados pessoais",
      description: this.dataStatusNumber
        ? "quantidade-de-etapas-pendentes:" + this.dataStatusNumber.toString()
        : "quantidade-de-etapas-pendentes:" + 0,
      implementation_team: this.analyticsPageGA4.implementationTeam,
    };

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl);
  }

  sendTrackGA4MaritalStatus() {
    const paramDefautl = {
      event_name: this.analyticsPageGA4.eventNameVisualization,
      custom_path: this.analyticsPageGA4.customPathOverview,
      detail: "Estado civil",
      description: this.dataStatusNumber
        ? "quantidade-de-etapas-pendentes:" + this.dataStatusNumber.toString()
        : "quantidade-de-etapas-pendentes:" + 0,
      implementation_team: this.analyticsPageGA4.implementationTeam,
    };

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl);
  }

  sendTrackGA4Adress() {
    const paramDefautl = {
      event_name: this.analyticsPageGA4.eventNameVisualization,
      custom_path: this.analyticsPageGA4.customPathOverview,
      detail: "Endereço",
      description: this.dataStatusNumber
        ? "quantidade-de-etapas-pendentes:" + this.dataStatusNumber.toString()
        : "quantidade-de-etapas-pendentes:" + 0,
      implementation_team: this.analyticsPageGA4.implementationTeam,
    };

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl);
  }

  sendTrackGA4ProfessionalData() {
    const paramDefautl = {
      event_name: this.analyticsPageGA4.eventNameVisualization,
      custom_path: this.analyticsPageGA4.customPathOverview,
      detail: "Dados profissionais",
      description: this.dataStatusNumber
        ? "quantidade-de-etapas-pendentes:" + this.dataStatusNumber.toString()
        : "quantidade-de-etapas-pendentes:" + 0,
      implementation_team: this.analyticsPageGA4.implementationTeam,
    };

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl);
  }

  sendTrackGA4IncomeEquity() {
    const paramDefautl = {
      event_name: this.analyticsPageGA4.eventNameVisualization,
      custom_path: this.analyticsPageGA4.customPathOverview,
      detail: "Renda e patrimônio",
      description: this.dataStatusNumber
        ? "quantidade-de-etapas-pendentes:" + this.dataStatusNumber.toString()
        : "quantidade-de-etapas-pendentes:" + 0,
      implementation_team: this.analyticsPageGA4.implementationTeam,
    };

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl);
  }

  verifyCompleted() {
    this.listStatus = [
      {
        icon: "./assets/images/svg/icon-phone.svg",
        step: "Dados de contato",
        status: this.profileCompleted() ? "completo" : "pendente",
      },
      {
        icon: "/assets/images/svg/icon-avatar.svg",
        step: "Dados pessoais",
        status: this.journeyService.registratioJourney.data?.personalData
          ?.isCompleted
          ? "completo"
          : "pendente",
      },
      {
        icon: "/assets/images/svg/icon-pencil.svg",
        step: "Estado civil",
        status: this.journeyService.registratioJourney.data?.maritalStatus
          ?.isCompleted
          ? "completo"
          : "pendente",
      },
      {
        icon: "/assets/images/svg/icon-house.svg",
        step: "Endereço",
        status: this.journeyService.registratioJourney.data?.address
          ?.isCompleted
          ? "completo"
          : "pendente",
      },
      {
        icon: "/assets/images/svg/icon-wallet.svg",
        step: "Dados profissionais",
        status: this.journeyService.registratioJourney.data?.professionalData
          ?.isCompleted
          ? "completo"
          : "pendente",
      },
      {
        icon: "/assets/images/svg/icon-dollar.svg",
        step: "Renda e patrimônio",
        status: this.journeyService.registratioJourney.data?.incomeEquity
          ?.isCompleted
          ? "completo"
          : "pendente",
      },
    ];

    this.dataStatusNumber = 0;
    if (Array.isArray(this.listStatus)) {
      this.listStatus.forEach((element) => {
        if (element.status === "pendente") {
          this.dataStatusNumber += 1;
          this.dataStatus = "pendente";
        }
        // DISPAROS GA4 VISUALIZATION
        setTimeout(() => {
          switch (element.status) {
            case "pendente":
              switch (element.step) {
                case "Dados de contato":
                  this.sendTrackGA4ContactData();
                  break;
                case "Dados pessoais":
                  this.sendTrackGA4PersonalData();
                  break;
                case "Estado civil":
                  this.sendTrackGA4MaritalStatus();
                  break;
                case "Endereço":
                  this.sendTrackGA4Adress();
                  break;
                case "Dados profissionais":
                  this.sendTrackGA4ProfessionalData();
                  break;
                case "Renda e patrimônio":
                  this.sendTrackGA4IncomeEquity();
                  break;
                default:
                  break;
              }
              break;
            default:
              break;
          }
        }, 500);
      });
    } else {
      console.error("this.listStatus não é um array");
    }
  }

  profileCompleted(): boolean {
    if (
      this.journeyService.registratioJourney.data?.profileData?.name !== undefined &&
      this.journeyService.registratioJourney.data?.profileData?.name !== "" &&
      this.journeyService.registratioJourney.data?.profileData?.email !== undefined &&
      this.journeyService.registratioJourney.data?.profileData?.email !== "" &&
      this.journeyService.registratioJourney.data?.profileData?.phoneNumber !== undefined &&
      this.journeyService.registratioJourney.data?.profileData?.phoneNumber !== ""
    ) {
      return true;
    } else {
      return false;
    }
  }

  getName() {
    this.nameNative =
      this.journeyService.registratioJourney.data?.profileData?.name === undefined ||
      this.journeyService.registratioJourney.data?.profileData?.name === ""
      ? this.journeyService.registratioJourney.data.personalData.name
      : this.journeyService.registratioJourney.data?.profileData?.name;
  }

  /* istanbul ignore next */
  ionViewWillEnter() {
    this.headerFocus();
    this.verifyCompleted();
    this.getName();
    this.analyticsData();
    this.sendTrackGA4LoadPage();
  }

  ionViewDidLeave() {
    this.ariaHidden = true;
  }

  setTitle() {
    this.title.setTitle(this.titlePage);
  }

  getPageId(): string {
    return this.headerId;
  }

  checkStatusPage(): boolean {
    const allComplete = this.listStatus.filter(
      (item) => item.status === "completo"
    );
    return (
      allComplete?.length === this.listStatus.length &&
      this.listStatus.length > 0
    );
  }

  analyticsEventClique() {
    const it_eventcategory = "Clique";
    const it_complementary = {
      it_eventaction: this.analyticsPage.action,
      it_eventlabel: this.analyticsPage.back,
      it_pagename: this.analyticsPage.checkData,
    };
    this.analycticsNativeService.analyticsTrackActionCommunicator(
      it_eventcategory,
      it_complementary
    );
  }

  analyticsEventCliqueCompleteLater() {
    const it_eventcategory = "Clique";
    const it_complementary = {
      it_eventaction: this.analyticsPage.action,
      it_eventlabel: this.analyticsPage.completeLater,
      it_pagename: this.analyticsPage.checkData,
    };
    this.analycticsNativeService.analyticsTrackActionCommunicator(
      it_eventcategory,
      it_complementary
    );
  }

  analyticsEventCliqueCompleteRegistration() {
    const it_eventcategory = "Clique";
    const it_complementary = {
      it_eventaction: this.analyticsPage.action,
      it_eventlabel: this.analyticsPage.completeRegistration,
      it_pagename: this.analyticsPage.checkData,
    };
    this.analycticsNativeService.analyticsTrackActionCommunicator(
      it_eventcategory,
      it_complementary
    );
  }

  backPage() {
    this.analyticsEventClique();
    if (this.cameFromLogin) {
      localStorage.removeItem("cameFromLogin");
      this.returnHomeService.returnCommunicator();
    } else {
      this.backJourney();
    }
  }

  clickEnd() {
    this.analyticsEventCliqueCompleteLater();
    this.sendTrackGA4CompleteLater();
    if (this.cameFromLogin) {
      localStorage.removeItem("cameFromLogin");
    }

    this.returnHomeService.returnCommunicator();
  }

  clickNextPage() {
    this.analyticsEventCliqueCompleteRegistration();
    this.sendTrackGA4CompleteNow();
    if (
      this.journeyService.journey === TrackTypes.BASIC_PROFILE_V2 ||
      this.journeyService.journey === TrackTypes.BASIC_PERSONAL_V2 ||
      this.journeyService.journey === TrackTypes.BASIC_MARITAL_V2 ||
      this.journeyService.journey === TrackTypes.BASIC_PROFESSIONAL_V2 ||
      this.journeyService.journey === TrackTypes.BASIC_INCOME_V2
    ) {
      this.router.navigateForward(["data", "client-data"]);
    } else {
      this.nextPage();
    }
  }
  showAlertVoiceOver() {
    this.alertVoiceOver = true;
    setTimeout(() => (this.alertVoiceOver = false), 1000);
  }
}
